import { render, staticRenderFns } from "./AssignmentView.vue?vue&type=template&id=740823ad&"
import script from "./AssignmentView.vue?vue&type=script&lang=js&"
export * from "./AssignmentView.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentView.vue?vue&type=style&index=0&id=740823ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports